// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R7Hxo","delete":"styles_delete__lEz4O","update":"styles_update__272Mr","add":"styles_add__1q1H6"};